module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/serejkakovalev-avatar-d14ce14a5eb8d08b489da601b7d33e21.jpg";